import {MenuItem, Select, SelectChangeEvent} from "@mui/material";

interface DropDownProps {
    label?: string;
    className?: string;
    value: number;
    disabled?: boolean;
    setValue: (event: SelectChangeEvent) => void;
    items: { itemValue: number, itemText: string, otherItems?: any[] }[]
}

export const DropDown = (props: DropDownProps) => {
    const renderItems = () => {
        const html = [];
        for (const item of props.items) {
            html.push(
                <MenuItem key={`vene-dropdown-${item.itemText}:${item.itemValue}`} value={item.itemValue}>{item.itemText}</MenuItem>
            )
        }

        return html;
    }

    return (
        <div className='vene-dropdown'>
            {props.label && (
                <div className='dropdown-label'>
                    <label htmlFor={props.label}>{props.label}</label>
                </div>
            )}
            <div className='dropdown-container'>
                <Select
                    labelId={props.label}
                    value={String(props.value)}
                    onChange={props.setValue}
                    className={props.className ? `${props.className} standard-dropdown` : 'standard-dropdown'}
                    disabled={props.disabled ? props.disabled : false}
                >
                    {renderItems()}
                </Select>
            </div>
        </div>
    )
}